import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { type UserState } from './userTypes';
import { authTokenHandlerInstance } from '../../helpers/authTokenHelper';
import type { AppView } from '../../types/app';

const initialState: UserState = {
  isLoggedIn: false,
  businessName: '',
  firstName: '',
  lastName: '',
  email: '',
  streetAddress: '',
  streetAddress2: '',
  postCode: '',
  city: '',
  country: '',
  phoneNumber: '',
  privacyPolicy: false,
  firstNamePhonetic: '',
  lastNamePhonetic: '',
  customerType: '',
  allowedMemberDiscounts: false,
  allowPersonalEmail: undefined,
};

export const getUserInformation = createAsyncThunk(
  'user/getUserInformation',
  async (view: AppView, { rejectWithValue }) => {
    const { result, error } =
      await authTokenHandlerInstance.getUserInformation(view);

    if (error || !result) {
      return rejectWithValue(error);
    }

    return result;
  },
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInformation: (state, action: { payload: UserState }) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserInformation.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    });
  },
});

export const { setUserInformation } = userSlice.actions;

export default userSlice.reducer;
